import Skeleton from "@mui/material/Skeleton";
import BoxComponent from "./components/MUIcomponents/BoxComponent/BoxComponent";
import StackComponent from "./components/MUIcomponents/StackComponent/StackComponent";

const MagazineSkeleton = () => {
  return (
    <BoxComponent width="100%" sx={{ px: { xs: 2, sm: 4, md: 8 }, pt: 4 }}>
      <StackComponent spacing={4} width="100%">
        <Skeleton variant="rectangular" height={120} width={342} />
        <StackComponent
          direction={{ xs: "column", md: "row" }}
          spacing={4}
          justifyContent="center"
          alignItems="flex-start"
          width="100%"
        >
          <StackComponent spacing={3} width={{ xs: 342, md: 488, lg: 808 }}>
            <Skeleton variant="rectangular" height={56} width="100%" />
            <Skeleton variant="rectangular" height={320} width="100%" />
          </StackComponent>
          <StackComponent spacing={2} width={{ xs: 342, md: 194, lg: 394 }}>
            <Skeleton variant="rectangular" height={56} width="100%" />
            <Skeleton variant="rectangular" height={200} width="100%" />
          </StackComponent>
        </StackComponent>
        <StackComponent spacing={1} width="100%">
          {Array.from({ length: 3 }).map((_, index) => (
            <StackComponent
              key={index}
              sx={{
                display: "flex",
                flexDirection: "row",
                borderBottom: "1px solid #D9D9D9",
                py: "24px",
                alignItems: "center",
                width: "100%",
                paddingLeft: { xs: 1, sm: 2, md: 24, lg: 39, xl: 39 },
                gap: { xs: 2, sm: 3, md: 7, lg: 11, xl: 11 },
              }}
            >
              <StackComponent
                sx={{
                  width: {
                    xl: "568px",
                    lg: "568px",
                    md: "288px",
                    sm: "128px",
                    xs: "188px",
                  },
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                <StackComponent flexDirection="row" alignItems="left" gap={2}>
                  <Skeleton
                    variant="text"
                    width={100}
                    height={20}
                  />
                  <Skeleton
                    variant="text"
                    width={100}
                    height={20}
                  />
                </StackComponent>

                <StackComponent
                  spacing={2}
                  sx={{
                    display: "flex",
                    width: { lg: "600px", md: "351px", xs: "100px" },
                    flexDirection: "column",
                  }}
                >
                  <Skeleton
                    variant="text"
                    height={20}
                    sx={{
                      fontSize: "1rem",
                      width: { lg: 300, md: 200, sm: 150, xs: 100 },
                    }}
                  />
                  <Skeleton
                    variant="text"
                    height={20}
                    sx={{
                      fontSize: "1rem",
                      width: { lg: 300, md: 200, sm: 150, xs: 100 },
                    }}
                  />
                  <Skeleton
                    variant="text"
                    height={20}
                    sx={{
                      fontSize: "1rem",
                      width: { lg: 300, md: 200, sm: 150, xs: 100 },
                    }}
                  />
                  <StackComponent flexDirection="row" gap={2}>
                    <Skeleton
                      variant="text"
                      width={100}
                      height={20}

                    />
                    <Skeleton
                      variant="text"
                      width={100}
                      height={20}

                    />
                    <Skeleton
                      variant="text"
                      width={100}
                      height={20}

                    />
                  </StackComponent>
                </StackComponent>
              </StackComponent>

              <Skeleton
                variant="rectangular"
                sx={{
                  borderRadius: "8px",
                  height: { lg: 130, md: 130, sm: 130, xs: 70 },
                  width: { lg: 150, md: 150, sm: 100, xs: 100 },
                }}
              />
            </StackComponent>
          ))}
        </StackComponent>
        <BoxComponent sx={{ position: "fixed", bottom: 32, right: 32 }}>
          <Skeleton variant="circular" width={56} height={56} />
        </BoxComponent>
      </StackComponent>
    </BoxComponent>
  );
};

const ArticleManagementSkeleton = () => {
  return (
    <BoxComponent
      width="100%"
      height="100vh"
      sx={{ px: { xs: 0, md: 0 }, pt: 0 }}
    >
      <StackComponent direction="row" width="100%" height="100vh">
        <BoxComponent
          sx={{
            width: 200,
            borderRight: "1px solid #E6E6E6",
            px: 2,
            py: 2,
            display: { xs: "none", md: "block" },
          }}
        >
          <StackComponent spacing={3}>
            <Skeleton
              variant="rectangular"
              width={136}
              height={88}
              sx={{ borderRadius: 2, mx: "auto" }}
            />
            <StackComponent spacing={2}>
              <Skeleton variant="rectangular" height={40} />
              <Skeleton variant="text" width={120} height={18} />
              <StackComponent spacing={1}>
                <Skeleton variant="text" width={150} height={18} />
                <Skeleton variant="text" width={110} height={18} />
                <Skeleton variant="text" width={130} height={18} />
              </StackComponent>
              <Skeleton variant="text" width={90} height={18} />
              <StackComponent spacing={1}>
                <Skeleton variant="text" width={140} height={18} />
                <Skeleton variant="text" width={100} height={18} />
                <Skeleton variant="text" width={130} height={18} />
              </StackComponent>
              <Skeleton variant="text" width={60} height={18} />
            </StackComponent>
            <StackComponent spacing={1} mt="auto">
              <Skeleton variant="text" width={60} height={18} />
              <Skeleton variant="text" width={120} height={18} />
            </StackComponent>
            <Skeleton
              variant="text"
              width={60}
              height={14}
              sx={{ position: "absolute", bottom: 16 }}
            />
          </StackComponent>
        </BoxComponent>

        <BoxComponent sx={{ flex: 1, bgcolor: "#F7F7FB" }}>
          <BoxComponent
            sx={{
              width: "98%",
              height: 64,
              borderBottom: "1px solid #E6E6E6",
              px: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              bgcolor: "#fff",
            }}
          >
            <StackComponent direction="row" spacing={2} alignItems="center">
              <Skeleton variant="circular" width={32} height={32} />
              <Skeleton
                variant="rectangular"
                width={40}
                height={24}
                              />
              <Skeleton variant="circular" width={32} height={32} />
            </StackComponent>
          </BoxComponent>
          <BoxComponent sx={{ p: 3 }}>
            <StackComponent spacing={2}>
              <Skeleton variant="text" width={240} height={36} />
              <StackComponent direction="row" spacing={3}>
                {Array.from({ length: 7 }).map((_, i) => (
                  <Skeleton
                    key={i}
                    variant="rectangular"
                    width={110}
                    height={28}
                  />
                ))}
              </StackComponent>

              <StackComponent spacing={1} direction="row" alignItems="center">
                <Skeleton variant="circular" width={20} height={20} />
                <Skeleton
                  variant="rectangular"
                  width={92}
                  height={32}
                                  />
                <Skeleton variant="circular" width={20} height={20} />
                <Skeleton
                  variant="rectangular"
                  width={120}
                  height={32}
                                  />
                <Skeleton variant="circular" width={20} height={20} />
                <Skeleton
                  variant="rectangular"
                  width={160}
                  height={32}
                                  />
                <Skeleton
                  variant="rectangular"
                  width={110}
                  height={32}
                                  />
                <Skeleton
                  variant="rectangular"
                  width={150}
                  height={32}
                                  />
              </StackComponent>

              <BoxComponent
                sx={{
                  border: "1px solid #E6E6E6",
                  borderRadius: 2,
                  overflow: "hidden",
                  bgcolor: "#fff",
                  mt: 1,
                }}
              >
                <StackComponent
                  direction="row"
                  alignItems="center"
                  sx={{
                    px: 2,
                    py: 1.5,
                    borderBottom: "1px solid #E6E6E6",
                    bgcolor: "#FAFAFC",
                  }}
                  spacing={2}
                >
                  <Skeleton
                    variant="rectangular"
                    width={16}
                    height={16}
                  />
                  <Skeleton variant="text" width={40} height={18} />
                  <Skeleton variant="text" width={220} height={18} />
                  <Skeleton variant="text" width={220} height={18} />
                  <Skeleton variant="text" width={160} height={18} />
                  <Skeleton variant="text" width={160} height={18} />
                  <Skeleton variant="text" width={120} height={18} />
                  <BoxComponent sx={{ ml: "auto" }}>
                    <Skeleton variant="text" width={100} height={18} />
                  </BoxComponent>
                </StackComponent>

                {Array.from({ length: 2 }).map((_, i) => (
                  <StackComponent
                    key={i}
                    direction="row"
                    alignItems="center"
                    sx={{
                      px: 2,
                      py: 2,
                      borderBottom: i === 1 ? "none" : "1px solid #E6E6E6",
                    }}
                    spacing={2}
                  >
                    <Skeleton
                      variant="rectangular"
                      width={16}
                      height={16}
                      />
                    <Skeleton variant="text" width={80} height={18} />
                    <Skeleton variant="text" width={260} height={18} />
                    <StackComponent spacing={0.5}>
                      <Skeleton variant="text" width={210} height={18} />
                      <Skeleton variant="text" width={140} height={14} />
                    </StackComponent>
                    <Skeleton variant="text" width={150} height={18} />
                    <Skeleton variant="text" width={110} height={18} />
                    <Skeleton
                      variant="rectangular"
                      width={110}
                      height={28}
                         />
                    <BoxComponent sx={{ ml: "auto" }}>
                      <Skeleton
                        variant="rectangular"
                        width={110}
                        height={32}
                          />
                    </BoxComponent>
                  </StackComponent>
                ))}
              </BoxComponent>

              <StackComponent
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{ px: 1, pt: 2 }}
              >
                <StackComponent direction="row" spacing={2} alignItems="center">
                  <Skeleton variant="text" width={100} height={16} />
                  <Skeleton
                    variant="rectangular"
                    width={32}
                    height={28}
                  />
                </StackComponent>
                <StackComponent direction="row" spacing={1} alignItems="center">
                  <Skeleton variant="text" width={70} height={16} />
                  <Skeleton variant="circular" width={28} height={28} />
                  <Skeleton variant="circular" width={28} height={28} />
                </StackComponent>
              </StackComponent>
            </StackComponent>
          </BoxComponent>
        </BoxComponent>
      </StackComponent>
    </BoxComponent>
  );
};

const ProfileContentSkeleton = () => {
  return (
    <BoxComponent
      width="100%"
      height="100vh"
      sx={{ px: { xs: 0, md: 0 }, pt: 0 }}
    >
      <StackComponent direction="row" width="100%" height="100vh">
        <BoxComponent
          sx={{
            width: 200,
            borderRight: "1px solid #E6E6E6",
            px: 2,
            py: 2,
            display: { xs: "none", md: "block" },
          }}
        >
          <StackComponent spacing={3}>
            <Skeleton
              variant="rectangular"
              width={136}
              height={88}
              sx={{ borderRadius: 2, mx: "auto" }}
            />
            <StackComponent spacing={2}>
              <Skeleton variant="rectangular" height={40} />
              <Skeleton variant="text" width={120} height={18} />
              <StackComponent spacing={1}>
                <Skeleton variant="text" width={150} height={18} />
                <Skeleton variant="text" width={110} height={18} />
                <Skeleton variant="text" width={130} height={18} />
              </StackComponent>
              <Skeleton variant="text" width={90} height={18} />
              <StackComponent spacing={1}>
                <Skeleton variant="text" width={140} height={18} />
                <Skeleton variant="text" width={100} height={18} />
                <Skeleton variant="text" width={130} height={18} />
              </StackComponent>
              <Skeleton variant="text" width={60} height={18} />
            </StackComponent>
            <StackComponent spacing={1} mt="auto">
              <Skeleton variant="text" width={60} height={18} />
              <Skeleton variant="text" width={120} height={18} />
            </StackComponent>
            <Skeleton
              variant="text"
              width={60}
              height={14}
              sx={{ position: "absolute", bottom: 16 }}
            />
          </StackComponent>
        </BoxComponent>

        <BoxComponent sx={{ flex: 1, bgcolor: "#F7F7FB" }}>
          <BoxComponent
            sx={{
              width: "98%",
              height: 64,
              borderBottom: "1px solid #E6E6E6",
              px: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              bgcolor: "#fff",
            }}
          >
            <StackComponent direction="row" spacing={2} alignItems="center">
              <Skeleton variant="circular" width={32} height={32} />
              <Skeleton
                variant="rectangular"
                width={40}
                height={24}
                              />
              <Skeleton variant="circular" width={32} height={32} />
            </StackComponent>
          </BoxComponent>
          <BoxComponent sx={{ width: "100%", p: 3 }}>
      <StackComponent spacing={2} width="100%">
        <Skeleton variant="text" width={160} height={36} />
        <StackComponent direction="row" spacing={2} alignItems="center">
          <StackComponent direction="row" spacing={1} alignItems="center"  width={440}>
            <Skeleton variant="circular" width={20} height={20} />
            <Skeleton variant="rectangular" height={40} sx={{ flex: 1, borderRadius: 1 }} />
          </StackComponent>
          <StackComponent direction="row" spacing={1} alignItems="center"  width={260}>
            <Skeleton variant="rectangular" height={40} sx={{ flex: 1, borderRadius: 1 }} />
            <Skeleton variant="rectangular" width={28} height={28} />
          </StackComponent>
        </StackComponent>

        <BoxComponent sx={{ border: "1px solid #E6E6E6", borderRadius: 2, overflow: "hidden", bgcolor: "#fff" }}>
          <StackComponent direction="row" alignItems="center" spacing={2} sx={{ px: 2, py: 1.5, bgcolor: "#F1F1F5", borderBottom: "1px solid #E6E6E6" }}>
            <Skeleton variant="text" width={90} height={18} />
            <Skeleton variant="text" width={120} height={18} />
            <Skeleton variant="text" width={220} height={18} />
            <Skeleton variant="text" width={200} height={18} />
            <Skeleton variant="text" width={220} height={18} />
            <BoxComponent >
              <Skeleton variant="rectangular" width={20} height={20} />
            </BoxComponent>
          </StackComponent>

          {Array.from({ length: 12 }).map((_, i) => (
            <StackComponent
              key={i}
              direction="row"
              alignItems="center"
              spacing={2}
              sx={{ px: 2, py: 2, borderBottom: i === 11 ? "none" : "1px solid #EDEDED" }}
            >
              <Skeleton variant="text" width={90} height={18} />
              <Skeleton variant="text" width={120} height={18} />
              <Skeleton variant="text" width={260} height={18} />
              <Skeleton variant="text" width={200} height={18} />
              <Skeleton variant="text" width={220} height={18} />
              <BoxComponent sx={{ ml: "auto" }}>
                <Skeleton variant="circular" width={18} height={18} />
              </BoxComponent>
            </StackComponent>
          ))}
        </BoxComponent>
      </StackComponent>
    </BoxComponent>
        </BoxComponent>
      </StackComponent>
    </BoxComponent>
  );
};

const MetricsPageSkeleton = () => {
  return (
    <BoxComponent
      width="100%"
      height="100vh"
      sx={{ px: { xs: 0, md: 0 }, pt: 0 }}
    >
      <StackComponent direction="row" width="100%" height="100vh">
        <BoxComponent
          sx={{
            width: 200,
            borderRight: "1px solid #E6E6E6",
            px: 2,
            py: 2,
            display: { xs: "none", md: "block" },
          }}
        >
          <StackComponent spacing={3}>
            <Skeleton variant="rectangular" width={136} height={88} sx={{ borderRadius: 2, mx: "auto" }} />
            <StackComponent spacing={2}>
              <Skeleton variant="rectangular" height={40} />
              <Skeleton variant="text" width={120} height={18} />
              <StackComponent spacing={1}>
                <Skeleton variant="text" width={150} height={18} />
                <Skeleton variant="text" width={110} height={18} />
                <Skeleton variant="text" width={130} height={18} />
              </StackComponent>
              <Skeleton variant="text" width={90} height={18} />
              <StackComponent spacing={1}>
                <Skeleton variant="text" width={140} height={18} />
                <Skeleton variant="text" width={100} height={18} />
                <Skeleton variant="text" width={130} height={18} />
              </StackComponent>
              <Skeleton variant="text" width={60} height={18} />
            </StackComponent>
            <StackComponent spacing={1} mt="auto">
              <Skeleton variant="text" width={60} height={18} />
              <Skeleton variant="text" width={120} height={18} />
            </StackComponent>
            <Skeleton variant="text" width={60} height={14} sx={{ position: "absolute", bottom: 16 }} />
          </StackComponent>
        </BoxComponent>

        <BoxComponent sx={{ flex: 1, bgcolor: "#F7F7FB" }}>
          <BoxComponent
            sx={{
              width: "98%",
              height: 64,
              borderBottom: "1px solid #E6E6E6",
              px: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              bgcolor: "#fff",
            }}
          >
            <StackComponent direction="row" spacing={2} alignItems="center">
              <Skeleton variant="circular" width={32} height={32} />
              <Skeleton variant="rectangular" width={40} height={24} />
              <Skeleton variant="circular" width={32} height={32} />
            </StackComponent>
          </BoxComponent>

          <BoxComponent sx={{ width: "100%", p: 3 }}>
            <StackComponent spacing={2} width="100%">
              <Skeleton variant="text" width={180} height={36} />
              <StackComponent direction="row" spacing={3} alignItems="center">
                <Skeleton variant="rectangular" width={96} height={32}  />
                <Skeleton variant="rectangular" width={96} height={32}  />
              </StackComponent>
              <StackComponent direction="row" spacing={2} alignItems="center">
                <StackComponent direction="row" spacing={1} alignItems="center" sx={{ width: 360 }}>
                  <Skeleton variant="circular" width={20} height={20} />
                  <Skeleton variant="rectangular" height={40} sx={{ flex: 1, borderRadius: 1 }} />
                </StackComponent>
                <StackComponent direction="row" spacing={1} alignItems="center" sx={{ width: 240 }}>
                  <Skeleton variant="rectangular" height={40} sx={{ flex: 1, borderRadius: 1 }} />
                  <Skeleton variant="rectangular" width={28} height={28} />
                </StackComponent>
                <StackComponent direction="row" spacing={2} alignItems="center">
                  <Skeleton variant="rectangular" width={140} height={40} />
                  <Skeleton variant="text" width={12} height={18} />
                  <Skeleton variant="rectangular" width={140} height={40} />
                  <Skeleton variant="rectangular" width={40} height={40} />
                </StackComponent>
              </StackComponent>

              <BoxComponent width="97%" sx={{ border: "1px solid #E6E6E6", borderRadius: 2, overflow: "hidden", bgcolor: "#fff" }}>
                <StackComponent direction="row" alignItems="center" spacing={2} sx={{ px: 2, py: 1.5, bgcolor: "#F1F1F5", borderBottom: "1px solid #E6E6E6" }}>
                  <Skeleton variant="text" width={280} height={18} />
                  <Skeleton variant="text" width={160} height={18} />
                  <Skeleton variant="text" width={120} height={18} />
                  <Skeleton variant="text" width={80} height={18} />
                  <Skeleton variant="text" width={100} height={18} />
                </StackComponent>

                {Array.from({ length: 5 }).map((_, i) => (
                  <StackComponent
                    key={i}
                    direction="row"
                    alignItems="center"
                    spacing={2}
                    sx={{ px: 2, py: 2, borderBottom: i === 4 ? "none" : "1px solid #EDEDED" }}
                  >
                    <Skeleton variant="text" width={420} height={18} />
                    <Skeleton variant="text" width={160} height={18} />
                    <Skeleton variant="text" width={120} height={18} />
                    <Skeleton variant="text" width={60} height={18} />
                    <Skeleton variant="text" width={60} height={18} />
                  </StackComponent>
                ))}
              </BoxComponent>

              <StackComponent direction="row" justifyContent="flex-end" alignItems="center" width={"97%"}>
                <StackComponent direction="row" spacing={2} alignItems="center">
                  <Skeleton variant="text" width={90} height={16} />
                  <Skeleton variant="rectangular" width={32} height={28}  />
                  <Skeleton variant="text" width={100} height={16} />
                  <Skeleton variant="circular" width={28} height={28} />
                  <Skeleton variant="circular" width={28} height={28} />
                </StackComponent>
              </StackComponent>
            </StackComponent>
          </BoxComponent>
        </BoxComponent>
      </StackComponent>
    </BoxComponent>
  );
};

const SettingsPageSkeleton = () => {
  return (
    <BoxComponent
      width="100%"
      height="100vh"
      sx={{ px: { xs: 0, md: 0 }, pt: 0 }}
    >
      <StackComponent direction="row" width="100%" height="100vh">
        <BoxComponent
          sx={{
            width: 200,
            borderRight: "1px solid #E6E6E6",
            px: 2,
            py: 2,
            display: { xs: "none", md: "block" },
          }}
        >
          <StackComponent spacing={3}>
            <Skeleton variant="rectangular" width={136} height={88} sx={{ borderRadius: 2, mx: "auto" }} />
            <StackComponent spacing={2}>
              <Skeleton variant="rectangular" height={40} />
              <Skeleton variant="text" width={120} height={18} />
              <StackComponent spacing={1}>
                <Skeleton variant="text" width={150} height={18} />
                <Skeleton variant="text" width={110} height={18} />
                <Skeleton variant="text" width={130} height={18} />
              </StackComponent>
              <Skeleton variant="text" width={90} height={18} />
              <StackComponent spacing={1}>
                <Skeleton variant="text" width={140} height={18} />
                <Skeleton variant="text" width={100} height={18} />
                <Skeleton variant="text" width={130} height={18} />
              </StackComponent>
              <Skeleton variant="text" width={60} height={18} />
            </StackComponent>
            <StackComponent spacing={1} mt="auto">
              <Skeleton variant="text" width={60} height={18} />
              <Skeleton variant="text" width={120} height={18} />
            </StackComponent>
            <Skeleton variant="text" width={60} height={14} sx={{ position: "absolute", bottom: 16 }} />
          </StackComponent>
        </BoxComponent>

        <BoxComponent sx={{ flex: 1, bgcolor: "#F7F7FB" }}>
          <BoxComponent
            sx={{
              width: "98%",
              height: 64,
              borderBottom: "1px solid #E6E6E6",
              px: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              bgcolor: "#fff",
            }}
          >
            <StackComponent direction="row" spacing={2} alignItems="center">
              <Skeleton variant="circular" width={32} height={32} />
              <Skeleton variant="rectangular" width={40} height={24} />
              <Skeleton variant="circular" width={32} height={32} />
            </StackComponent>
          </BoxComponent>

          <BoxComponent sx={{ width: "97%", p: 3 }}>
            <StackComponent spacing={2} width="100%">
              <Skeleton variant="text" width={200} height={36} />
              <StackComponent direction="row" spacing={3} alignItems="center">
                <Skeleton variant="rectangular" width={96} height={32}  />
                <Skeleton variant="rectangular" width={96} height={32}  />
                <Skeleton variant="rectangular" width={96} height={32}  />
                <Skeleton variant="rectangular" width={96} height={32}  />
                <Skeleton variant="rectangular" width={96} height={32}  />
              </StackComponent>

              <BoxComponent sx={{ border: "1px solid #E6E6E6", borderRadius: 2, p: 2, bgcolor: "#fff" }}>
                <StackComponent direction={{ xs: "column", lg: "row" }} spacing={3}>
                  <BoxComponent  flex={1}>
                    <Skeleton variant="text" width={260} height={24} />
                    <Skeleton variant="text" width={520} height={16} />
                    <Skeleton variant="text" width={480} height={16} />
                    <Skeleton variant="text" width={300} height={16} />
                  </BoxComponent>

                  <BoxComponent sx={{ flex: 1.2 }}>
                    <StackComponent spacing={2}>
                      <Skeleton variant="text" width={180} height={18} />
                      <Skeleton variant="rectangular" height={52}  />
                      <Skeleton variant="text" width={200} height={14} />
                      <Skeleton variant="text" width={200} height={18} />
                      <Skeleton variant="rectangular" height={120}  />
                      <Skeleton variant="text" width={260} height={14} />
                      <Skeleton variant="text" width={140} height={18} />
                      <Skeleton variant="rectangular" height={52}  />
                      <Skeleton variant="text" width={140} height={18} />
                      <Skeleton variant="rectangular" height={52}  />
                      <Skeleton variant="text" width={160} height={18} />
                      <Skeleton variant="rectangular" height={160}  />
                    </StackComponent>
                  </BoxComponent>
                </StackComponent>
              </BoxComponent>
            </StackComponent>
          </BoxComponent>
        </BoxComponent>
      </StackComponent>
    </BoxComponent>
  );
};


const UsersListSkeleton = () => {
return (
    <BoxComponent
      width="100%"
      height="100vh"
      sx={{ px: { xs: 0, md: 0 }, pt: 0 }}
    >
      <StackComponent direction="row" width="100%" height="100vh">
        <BoxComponent
          sx={{
            width: 200,
            borderRight: "1px solid #E6E6E6",
            px: 2,
            py: 2,
            display: { xs: "none", md: "block" },
          }}
        >
          <StackComponent spacing={3}>
            <Skeleton
              variant="rectangular"
              width={136}
              height={88}
              sx={{ borderRadius: 2, mx: "auto" }}
            />
            <StackComponent spacing={2}>
              <Skeleton variant="rectangular" height={40} />
              <Skeleton variant="text" width={120} height={18} />
              <StackComponent spacing={1}>
                <Skeleton variant="text" width={150} height={18} />
                <Skeleton variant="text" width={110} height={18} />
                <Skeleton variant="text" width={130} height={18} />
              </StackComponent>
              <Skeleton variant="text" width={90} height={18} />
              <StackComponent spacing={1}>
                <Skeleton variant="text" width={140} height={18} />
                <Skeleton variant="text" width={100} height={18} />
                <Skeleton variant="text" width={130} height={18} />
              </StackComponent>
              <Skeleton variant="text" width={60} height={18} />
            </StackComponent>
            <StackComponent spacing={1} mt="auto">
              <Skeleton variant="text" width={60} height={18} />
              <Skeleton variant="text" width={120} height={18} />
            </StackComponent>
            <Skeleton
              variant="text"
              width={60}
              height={14}
              sx={{ position: "absolute", bottom: 16 }}
            />
          </StackComponent>
        </BoxComponent>

        <BoxComponent sx={{ flex: 1, bgcolor: "#F7F7FB" }}>
          <BoxComponent
            sx={{
              width: "98%",
              height: 64,
              borderBottom: "1px solid #E6E6E6",
              px: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              bgcolor: "#fff",
            }}
          >
            <StackComponent direction="row" spacing={2} alignItems="center">
              <Skeleton variant="circular" width={32} height={32} />
              <Skeleton
                variant="rectangular"
                width={40}
                height={24}
                              />
              <Skeleton variant="circular" width={32} height={32} />
            </StackComponent>
          </BoxComponent>

          <BoxComponent sx={{ width: "100%", p: 3 }}>
            <StackComponent spacing={2} width="100%">
              <Skeleton variant="text" width={160} height={36} />
              <StackComponent direction="row" spacing={2} alignItems="center">
                <StackComponent direction="row" spacing={1} alignItems="center"  width={440}>
                  <Skeleton variant="circular" width={20} height={20} />
                  <Skeleton variant="rectangular" height={40} sx={{ flex: 1, borderRadius: 1 }} />
                </StackComponent>
                <StackComponent direction="row" spacing={1} alignItems="center"  width={260}>
                  <Skeleton variant="rectangular" height={40} sx={{ flex: 1, borderRadius: 1 }} />
                  <Skeleton variant="rectangular" width={28} height={28} />
                </StackComponent>
              </StackComponent>

              <BoxComponent sx={{ border: "1px solid #E6E6E6", borderRadius: 2, overflow: "hidden", bgcolor: "#fff" }}>
                <StackComponent direction="row" alignItems="center" spacing={2} sx={{ px: 2, py: 1.5, bgcolor: "#F1F1F5", borderBottom: "1px solid #E6E6E6" }}>
                  <Skeleton variant="text" width={90} height={18} />
                  <Skeleton variant="text" width={120} height={18} />
                  <Skeleton variant="text" width={220} height={18} />
                  <Skeleton variant="text" width={200} height={18} />
                  <Skeleton variant="text" width={220} height={18} />
                  <BoxComponent sx={{ ml: "auto" }}>
                    <Skeleton variant="rectangular" width={20} height={20} />
                  </BoxComponent>
                </StackComponent>

                {Array.from({ length: 12 }).map((_, i) => (
                  <StackComponent
                    key={i}
                    width={"100%"}
                    direction="row"
                    alignItems="center"
                    spacing={2}
                    sx={{ px: 2, py: 2, borderBottom: i === 11 ? "none" : "1px solid #EDEDED" }}
                  >
                    <Skeleton variant="text" width={140} height={18} />
                    <Skeleton variant="text" width={220} height={18} />
                    <Skeleton variant="text" width={360} height={18} />
                    <Skeleton variant="text" width={300} height={18} />
                    <Skeleton variant="text" width={320} height={18} />
                    <BoxComponent sx={{ ml: "auto" }}>
                      <Skeleton variant="circular" width={18} height={18} />
                    </BoxComponent>
                  </StackComponent>
                ))}
              </BoxComponent>
            </StackComponent>
          </BoxComponent>
        </BoxComponent>
      </StackComponent>
    </BoxComponent>
  );
}

type SelectSkeletonProps = {
  ventana: Location;
};

const SelectSkeleton: React.FC<SelectSkeletonProps> = ({ ventana }) => {
  switch (ventana.pathname) {
    case "/":
      return <MagazineSkeleton />;
    case "/dashboard/editor/editorpanel":
      return <ArticleManagementSkeleton />;
    case "/dashboard/editor/profile":
      return <ProfileContentSkeleton />;
    case "/dashboard/editor/users":
      return <UsersListSkeleton />;
    case "/dashboard/editor/configuration/":
      return <SettingsPageSkeleton />;
    case "/dashboard/editor/metrics":
      return <MetricsPageSkeleton/>;
    default:
      return null;
  }
};

const AppSkeleton: React.FC = () => {
  const ventana = window.location;

  return <SelectSkeleton ventana={ventana} />;
};

export default AppSkeleton;
